<template>
  <th @click.prevent="sortBy(sortField)">
    <template v-if="sort">
      <i v-if="sort == 'desc'" class="fas fa-angle-down"></i>
      <i v-else class="fas fa-angle-up"></i>
    </template>
    <slot></slot>
  </th>
</template>
<script>
export default {
  name: "th-sort-field",
  props: {
    sortField: {
      required: true,
      type: String
    },
    dataRow: {
      required: true
    }
  },
  data() {
    return {
      tableLines: [],
      sort: null
    };
  },
  methods: {
    sortBy(sortField) {
      if (sortField != "no-sort") {
        this.sort = this.sort == "desc" ? "asc" : "desc";

        this.$emit(
          "update:dataRow",
          _.orderBy(this.dataRow, sortField, this.sort)
        );
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Tables/ThSortField.vue